import AutoNumeric from "autonumeric";
import {autonumericOptions} from "./autonumeric";

// SELECT a cascata, UDP => PROJECTS => ITEMS, form edit_ascribed
function initAmountShareCascading() {
    const $containers = $('fieldset.amount-share')
    $.each($containers, function (i, container) {
        const $container = $(container);
        const selectUdp = $container.find(`[id^=journal_entry_amount_shares_attributes_][id$=udp_id]`)
        const selectProject = $container.find(`[id^=journal_entry_amount_shares_attributes_][id$=project_id]`)
        const selectItem = $container.find(`[id^=journal_entry_amount_shares_attributes_][id$=item_id]`)
        // carica progetti
        selectUdp.on('change.cascading', function (e) {
            $.getJSON(`/admin/journal_entries/projects?udp_id=${this.value}`, function (data) {
                const autoSelect = data.length === 1
                selectProject.find('option').remove()
                const newOption = new Option(" ", '', false, false);
                !autoSelect && selectProject.append(newOption);
                $.each(data, function (i, d) {
                    const newOption = new Option(d.name, d.id, false, autoSelect);
                    selectProject.append(newOption);
                })
                if (data.length === 0) {
                    selectProject.attr("disabled", "disabled")
                } else {
                    selectProject.removeAttr("disabled")
                }
                selectProject.trigger('change');
            })
        })

        // carica voci di spesa
        selectProject.on('change.cascading', function () {
            $.getJSON(`/admin/journal_entries/items?project_id=${this.value}`, function (data) {
                const autoSelect = data.length === 1
                selectItem.find('option').remove()
                const newOption = new Option(" ", '', false, false);
                !autoSelect && selectItem.append(newOption);
                $.each(data, function (i, d) {
                    const newOption = new Option(d.label, d.id, false, autoSelect);
                    selectItem.append(newOption);
                })
                if (data.length === 0) {
                    selectItem.attr("disabled", "disabled")
                } else {
                    selectItem.removeAttr("disabled")
                }
                selectItem.trigger('change');
            })
        })
    })
}


// CALCOLO TOTALI IN BASE AL NUMERO DI AMOUNT SHARE, form edit_ascribed
function initCloneAmount() {
    const $form = $('form.journal_entry')
    const $containers = $form.find('.clone-amount');
    const $elementToClone = $form.find('#journal_entry_total_net');
    $($elementToClone).trigger('change.sum-amount')

    const selector = `[id^=journal_entry_amount_shares_attributes_][id$=amount]`
    const selectorTotalNet = `[id^=journal_entry_amount_shares_attributes_][id$=total_net]`
    const selectorPercentage = `[id^=journal_entry_amount_shares_attributes_][id$=percentage]`

    let $acElementToClone = AutoNumeric.getAutoNumericElement(`#${$elementToClone.attr('id')}`);

    // inserisco cifra iniziale
    $.each($containers, function (i, el) {
        const cTotalNet = $(el).find(selectorTotalNet)
        const anElementTotalNet = AutoNumeric.getAutoNumericElement(cTotalNet.get(0));
        const totalValCurrent = anElementTotalNet.getNumber();
        if ($acElementToClone.getNumber() && totalValCurrent === 0) {
            anElementTotalNet.set($acElementToClone.getNumber())
        }
    })

    // AUTOCOMPLETE
    // if ($containers.length === 1 && $elementToClone.length > 0) {
    $($elementToClone).off("change.clone-amount keyup.clone-amount paste.clone-amount")
    $($elementToClone).on("change.clone-amount keyup.clone-amount paste.clone-amount", function () {
        const totalVal = $acElementToClone.getNumber()
        $.each($containers, function (i, el) {
            const cAmount = $(el).find(selector)
            const cPercentage = $(el).find(selectorPercentage)
            const cTotalNet = $(el).find(selectorTotalNet)
            const anElement = AutoNumeric.getAutoNumericElement(cAmount.get(0));
            const anElementTotalNet = AutoNumeric.getAutoNumericElement(cTotalNet.get(0));
            const anElementPercentage = AutoNumeric.getAutoNumericElement(cPercentage.get(0));
            let $acElementToClone = AutoNumeric.getAutoNumericElement(`#${$elementToClone.attr('id')}`);

            const totalValCurrent = anElementTotalNet.getNumber();
            const lastTotalVal = parseFloat($elementToClone.data('last-value')) || 0

            if ((lastTotalVal === totalValCurrent) || (totalValCurrent === 0)) {

                anElementTotalNet.set(totalVal)
            }

            if (anElementPercentage && cPercentage.val() && totalVal > 0) {
                const currentPercentage = anElementPercentage.getNumber()
                anElement.set(totalVal * currentPercentage / 100)
                // anElementPercentage.set(currentPercentage)
            }
        });
        $elementToClone.data('last-value', totalVal)

        // el.val($elementToClone.val())
        // console.log(el.val())
    })
    // } else {
    //     $($elementToClone).off("change.clone-amount keyup.clone-amount paste.clone-amount")
    // }

    // SUM

    let $totalEl = $form.find('.total-amounts')
    let $diffEl = $form.find('.diff-amounts')
    if ($diffEl.length === 0) {
        $form.find('*[data-has-many-association="amount_shares"] .has-many-fields-title').after("<span class='diff-amounts'></span>")
    }
    if ($totalEl.length === 0) {
        $form.find('*[data-has-many-association="amount_shares"] .has-many-fields-title').after("<span class='total-amounts'></span>")
    }
    $totalEl = $form.find('.total-amounts')
    $diffEl = $form.find('.diff-amounts')

    if ($containers.length > 0) {
        $.each($containers, function (i, el) {
            $(el).find(selector).off("change.sum-amount keyup.sum-amount paste.sum-amount")
            $(el).find(selector).on("change.sum-amount keyup.sum-amount paste.sum-amount", function () {
                calculateTotal($containers, selector, $totalEl, $acElementToClone, $diffEl)
            })
            $($elementToClone).off("change.sum-amount keyup.sum-amount paste.sum-amount")
            $($elementToClone).on("change.sum-amount keyup.sum-amount paste.sum-amount", function () {
                calculateTotal($containers, selector, $totalEl, $acElementToClone, $diffEl)
            })
        })
        $containers?.first()?.find(selector)?.trigger('change.sum-amount')
    }

}

function calculateTotal($containers, selector, $totalEl, $acElementToClone, $diffEl) {
    let label = "Totale somma imputazioni: __TOT__"
    let labelDiff = "Imputazione residua: __TOT__"
    let tot = 0
    $.each($containers.find(selector), function (i, el) {
        const anElement = AutoNumeric.getAutoNumericElement(`#${$(el).attr('id')}`);
        tot += anElement ? anElement.getNumber() : 0
    })
    const disabledAscribedValue = parseFloat(AutoNumeric.unformat($('.amount-disabled-value').text()?.replaceAll(".", ' ')?.replaceAll(" €", ''), autonumericOptions) || 0)
    $totalEl.text(label.replace('__TOT__', AutoNumeric.format(tot + disabledAscribedValue, autonumericOptions)))
    $diffEl.text(labelDiff.replace('__TOT__', AutoNumeric.format(($acElementToClone?.getNumber()) - tot - disabledAscribedValue, autonumericOptions)))
}

function initOnChangeAmountShare() {
    const $form = $('form.journal_entry')
    // const $elementToClone = $form.find('#journal_entry_total_net');
    // const amountInputInstance = AutoNumeric.getAutoNumericElement($elementToClone.get(0));
    const sel = `input[id^=journal_entry_amount_shares_attributes_][id$=percentage]`
    const selAm = `input[id^=journal_entry_amount_shares_attributes_][id$=amount]`
    $(sel).each(function (i, el) {
        $(el).off('change.sync-per-am keyup.sync-per-am paste.sync-per-am')
        $(el).on('change.sync-per-am keyup.sync-per-am paste.sync-per-am', function () {
            const amountInputAS = $(this).closest('fieldset.amount-share').find(`input[id^=journal_entry_amount_shares_attributes_][id$=amount]`)
            const $elementToClone = $(this).closest('fieldset.amount-share').find(`input[id^=journal_entry_amount_shares_attributes_][id$=total_net]`)
            const amountInputInstance = AutoNumeric.getAutoNumericElement($elementToClone.get(0));
            const amountInputInstanceAS = AutoNumeric.getAutoNumericElement(amountInputAS.get(0));
            const percentageInputInstance = AutoNumeric.getAutoNumericElement($(this).get(0));
            const currentAmount = amountInputInstance.getNumber() * percentageInputInstance.getNumber() / 100
            amountInputInstanceAS.set(currentAmount)
            $(selAm).trigger("change.sum-amount")
        })
    })

    $(selAm).each(function (i, el) {
        $(el).off('change.sync-am-per keyup.sync-am-per paste.sync-am-per')
        $(el).on('change.sync-am-per keyup.sync-am-per paste.sync-am-per', function () {
            const percentageInputAS = $(this).closest('fieldset.amount-share').find(`input[id^=journal_entry_amount_shares_attributes_][id$=percentage]`)
            const percentageInputInstanceAS = AutoNumeric.getAutoNumericElement(percentageInputAS.get(0));
            // const amountInputInstanceAS = AutoNumeric.getAutoNumericElement($(this).get(0));
            // const currentPercentage = parseFloat(amountInputInstanceAS.getNumber() / amountInputInstance.getNumber() * 100).toFixed(2)
            percentageInputInstanceAS.set('')
        })
    })
}

export {  initAmountShareCascading, initCloneAmount, initOnChangeAmountShare}